export default __webpack_public_path__ + "static/media/zoom_out_enable.6a851aa9.svg";